import { Stack, Toast } from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import Switch from "react-switch"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import Preloader from "../../components/WishlistApp/Preloader"
import formatDateTime from "../../utils/formatDateTime"
import "./styles.scss"

function mapStateToProps(state) {
    return {
        widgets: state.widgets,
        pages: state.pages,
        app_settings: state.app_settings,
        app_render: state.app_render,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class ReminderEmailManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            app_settings: JSON.parse(JSON.stringify(props.app_render)),
            isLoading: false,
            toast: {
                show: false,
                content: "",
                error: false,
            },
            wishlist_settings_edited: [],
            compare_settings_edited: [],
            general_settings_edited: [],
            copied: {},
        }
    }

    componentDidMount() {
        const { actions, widgets } = this.props
    }

    checkWidget = () => {
        let { widgets } = this.props
        widgets = widgets[3]
        return widgets
    }

    /**
     * Cache edited setting
     */
    cacheSetting(type: String, editObj: Object) {
        const settingKey =
            type === "wishlist"
                ? "wishlist_settings"
                : type === "compare"
                ? "compare_settings"
                : "general_settings"
        const editObjKey = Object.keys(editObj)[0]
        const editObjVal = Object.values(editObj)[0]
        const { app_settings, actions } = this.props
        const {
            wishlist_settings_edited,
            compare_settings_edited,
            general_settings_edited,
        } = this.state
        const handleList =
            type === "wishlist"
                ? wishlist_settings_edited
                : type === "compare"
                ? compare_settings_edited
                : general_settings_edited
        const handleKey =
            type === "wishlist"
                ? "wishlist_settings_edited"
                : type === "compare"
                ? "compare_settings_edited"
                : "general_settings_edited"
        const propObjVal = app_settings[settingKey][editObjKey]
        let compareFlag = false
        if (!Array.isArray(editObjVal)) {
            // Normal value
            if (typeof editObjVal !== "object") {
                if (editObjVal === propObjVal) {
                    compareFlag = true
                }
            }
            // Object value
            else {
                if (
                    JSON.stringify({
                        ...this.state.app_settings[settingKey][editObjKey],
                        ...editObjVal,
                    }) === JSON.stringify(propObjVal)
                ) {
                    compareFlag = true
                }
            }
        } else {
            editObjVal.sort()
            propObjVal.sort()
            if (editObjVal.join() === propObjVal.join()) {
                compareFlag = true
            }
        }

        let newList = []
        let checkItemExisted = handleList.findIndex((item) => {
            let itemKey = Object.keys(item)[0]
            return itemKey === editObjKey
        })

        if (!compareFlag) {
            if (checkItemExisted !== -1) {
                newList = handleList.map((item) => {
                    let itemKey = Object.keys(item)[0]
                    if (itemKey === editObjKey) {
                        if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                            return {
                                [editObjKey]: {
                                    ...this.state.app_settings[settingKey][editObjKey],
                                    ...editObjVal,
                                },
                            }
                        } else {
                            return editObj
                        }
                    } else {
                        return item
                    }
                })
            } else {
                if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                    newList = handleList.concat([
                        {
                            [editObjKey]: {
                                ...this.state.app_settings[settingKey][editObjKey],
                                ...editObjVal,
                            },
                        },
                    ])
                } else {
                    newList = handleList.concat([editObj])
                }
            }
        } else {
            newList = handleList.filter((item) => {
                let itemKey = Object.keys(item)[0]
                return itemKey !== editObjKey
            })
        }

        this.setState({
            [handleKey]: newList,
        })
        actions.changeAppEditedAction(handleKey, newList)
        this.changeSetting()
    }

    changeSetting() {
        const { actions, pages } = this.props
        setTimeout(() => {
            actions.changeAppRenderAction("wishlist", this.state.app_settings.wishlist_settings)
        }, 0)
    }

    enableSettings = () => {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                wishlist_settings: {
                    ...this.state.app_settings.wishlist_settings,
                    reminder_mail: !this.state.app_settings.wishlist_settings.reminder_mail,
                },
            },
        })
        setTimeout(() => {
            // Cache edited setting
            this.cacheSetting("wishlist", {
                reminder_mail: this.state.app_settings.wishlist_settings.reminder_mail,
            })
        }, 0)
    }
    renderTableBody = () => {
        const { actions, redirectToPage, pages } = this.props
        const widgets = this.checkWidget()
        const { copied } = this.state
        return (
            <tbody>
                {JSON.parse(JSON.stringify(widgets)).map((item, index) => (
                    <tr key={item.id}>
                        <td>
                            <div
                                className="item-title"
                                onClick={async () => {
                                    await actions.changeWidgetSelectedAction(item)
                                    redirectToPage("ReminderEmailSetting")
                                }}
                            >
                                {item.name}
                            </div>
                        </td>
                        <td>
                            <div className="item-text updated-at">
                                {formatDateTime(widgets.updated_at, "Month DD, YYYY")}
                            </div>
                        </td>
                        <td>
                            <div className="btn-icon-group">
                                <div
                                    className="btn-icon"
                                    onClick={async () => {
                                        await actions.changeWidgetSelectedAction(item)
                                        redirectToPage("ReminderEmailSetting")
                                    }}
                                >
                                    <div className="icon icon-edit" />
                                    <div>Edit</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        )
    }

    renderWidgetsManagement = () => {
        const { actions, pages } = this.props
        const sendMailEnable =
            this.props.plan.plan == "free"
                ? false
                : this.state.app_settings.wishlist_settings.reminder_mail
        const disableStyle =
            this.props.plan.plan == "free" ? { opacity: 0.5, pointerEvents: "none" } : {}
        return (
            <div className="widgets-management-body" style={disableStyle}>
                <div className="title-block">
                    <Stack distribution="equalSpacing" alignment="center">
                        <Stack.Item fill>
                            <Stack alignment="center" spacing="extraLoose">
                                <div className="page-title">Reminder Email Settings</div>
                            </Stack>
                        </Stack.Item>
                        <Stack.Item>
                            <Stack alignment="center">
                                <div
                                    onClick={() => this.enableSettings()}
                                    className={`yta-custom yta-custom-${
                                        sendMailEnable ? "enabled" : "disabled"
                                    }`}
                                >
                                    {sendMailEnable ? "Enabled" : "Disabled"}
                                </div>
                                <Switch
                                    height={20}
                                    width={46}
                                    onChange={() => this.enableSettings()}
                                    checked={sendMailEnable}
                                />
                            </Stack>
                        </Stack.Item>
                    </Stack>
                </div>

                <div className="subtitle-block">
                    <div className="page-text">
                        Configure the Reminder Email Settings that will be reflected across
                        your store.
                    </div>
                </div>

                <div className="table-block-body">
                    <table>
                        <thead className="">
                            <tr>
                                <th>NAME</th>
                                <th>LAST UPDATED</th>
                                <th>ACTIONS</th>
                            </tr>
                        </thead>

                        {this.renderTableBody()}
                    </table>
                </div>
            </div>
        )
    }
    render() {
        const { toast, isLoading } = this.state

        return (
            <div>
                <div className="bis-management">
                    {this.renderWidgetsManagement()}
                    {isLoading && <Preloader />}

                    {toast.show && (
                        <Toast
                            content={toast.content}
                            error={toast.error}
                            onDismiss={() =>
                                this.setState({
                                    toast: { show: false, content: "", error: false },
                                })
                            }
                        />
                    )}
                    {this.props.plan.plan == "free" && (
                        <span className="tooltiptext">Please upgrade your Plan to use this feature</span>
                    )}
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReminderEmailManagement)
